export default __webpack_public_path__ + "static/media/coriander.e987851f.jpeg";